import { Link, useLocation } from "@/lib/router-compat";
import { CalendarCheck, MapPin, Glasses, MessageCircle } from "lucide-react";
import { useCountry } from "@/hooks/useCountry";
import { buildWhatsAppUrl } from "@/lib/whatsapp";

export function MobileBottomNav() {
  const { country, t } = useCountry();
  const location = useLocation();

  const navItems = [
    { icon: CalendarCheck, label: t("nav.eyeTest"), href: `/${country.slug}/book`, ctaName: "book_free_eye_test" },
    { icon: MapPin, label: t("nav.stores"), href: `/${country.slug}/stores`, ctaName: "find_store" },
    { icon: Glasses, label: t("nav.glasses"), href: `/${country.slug}/glasses`, ctaName: "browse_frames" },
  ];

  const whatsappUrl = buildWhatsAppUrl(country.whatsappNumber) ?? "#";

  return (
    <nav data-mobile-nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background border-t border-border safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const isActive = location.pathname.startsWith(item.href);
          return (
            <Link
              key={item.href}
              to={item.href}
              onClick={() => {
                import("@/lib/analytics/track").then(({ track }) =>
                  track("cta_click", {
                    cta_name: item.ctaName,
                    cta_type: "primary",
                    cta_location: "mobile_bottom_nav",
                    destination_url: item.href,
                  })
                );
              }}
              className={`flex flex-col items-center gap-0.5 text-xs font-medium transition-colors ${
                isActive ? "text-primary" : "text-muted-foreground"
              }`}
            >
              <item.icon className="h-5 w-5" />
              <span>{item.label}</span>
            </Link>
          );
        })}
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center gap-0.5 text-xs font-medium text-success transition-colors"
        >
          <MessageCircle className="h-5 w-5" />
          <span>{t("nav.whatsapp")}</span>
        </a>
      </div>
    </nav>
  );
}
